module.exports = __webpack_public_path__ + "static/media/bass-pro-shops-logo.68d3e835.jpg";